import Vue from "vue";
import Vuex from "vuex";

import Web3 from "web3";

import Contracts from "@/assets/contracts.matic";

import axios from "axios";

import FactoryABI from "@/assets/abis/Factory";
import AuctionABI from "@/assets/abis/Auction";
import PairABI from "@/assets/abis/Pair";
import Pair1ABI from "@/assets/abis/Pair1";

import ERC721ABI from "@/assets/abis/ERC721";
import ERC1155ABI from "@/assets/abis/ERC1155";
import DuckChefABI from "@/assets/abis/DuckChef";
import MasterChefABI from "@/assets/abis/MasterChef";
import MasterChefNewABI from "@/assets/abis/MasterChefNew";
import WrappedCatsABI from "@/assets/abis/WrappedCats";
import CatsCoreAbi from "@/assets/abis/CatsCore";
import NCTAbi from "@/assets/abis/INCT";

import NFT20Abi from "@/assets/abis/Pair";
import NFT20SwapperAbi from "@/assets/abis/NFT20Swapper";

import CoinGecko from "coingecko-api";
import BigNumber from "bignumber.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    web3: null,
    isLoaded: false,
    account: null,
    contracts: {},
    auctions: [],
    pairCount: 0,
    pairs: [],
    trendingPairs: [],
    currentProject: null,
    selectedNfts: [],
    selectedNftsIn: [],
    selectedNftsOut: [],
    tokenSelected: "",
    casDeposit: "",
    casWithdraw: "",
    casPrice: 0,
    didSelectNfts: false,
    isLoading: false,
    // network: process.env.NETWORK == null ? 0 : parseInt(process.env.NETWORK),
    network: 1,
    explorer: "https://etherscan.io/token/",
    correctNetwork: null,
  },
  mutations: {
    disconnectWallet: async function(state) {
      let web3 = new Web3(
        new Web3.providers.WebsocketProvider(
          `wss://mainnet.infura.io/ws/v3/412acf21edf5444a8c9f6bd737cf8ca3`
        )
      );
      if (context.state.network == 1) {
        web3 = new Web3(
          new Web3.providers.HttpProvider(
            "https://rpc-mainnet.maticvigil.com/v1/a1ee017415be247f46ba9757b4ad2391d28df3da"
          )
        );
      }
      state.web3 = web3;
      state.account = null;
    },
    setWeb3: async function(state, web3, vueInstance) {
      console.log("OLD ACCOUNT", state.account);
      if (state.web3 != null && state.account != null) {
        //   // state.web3 = null;
        return;
      }
      state.web3 = web3;
      state.account = (await web3.eth.getAccounts())[0];
      //state.account="0x5219dfbC22Fd5A7A2366814e4743cd38B5Ec9637"
      state.contracts = Contracts;

      state.UniEthMuseContract = new web3.eth.Contract(
        PairABI,
        Contracts.UniEthMuse
      );

      state.MasterChef = new web3.eth.Contract(
        MasterChefABI,
        Contracts.MasterChef
      );

      //This has to be update with new Masterchef contract
      state.NFT20MasterChef = new web3.eth.Contract(
        MasterChefNewABI,
        Contracts.MasterChefNew
      );
      state.Auction = new web3.eth.Contract(AuctionABI, Contracts.Auction);
      state.DuckChef = new web3.eth.Contract(DuckChefABI, Contracts.DuckChef);
      state.Factory = new web3.eth.Contract(FactoryABI, Contracts.Factory);

      state.NCT = new web3.eth.Contract(NCTAbi, Contracts.NCT);

      state.Pair = async (contract) => {
        return new web3.eth.Contract(PairABI, contract);
      };
      state.Pair1 = async (contract) => {
        return new web3.eth.Contract(Pair1ABI, contract);
      };
      state.ERC721 = async (contract) => {
        return new web3.eth.Contract(ERC721ABI, contract);
      };

      state.ERC1155 = async (contract) => {
        return new web3.eth.Contract(ERC1155ABI, contract);
      };

      state.CasContract = new web3.eth.Contract(
        NFT20SwapperAbi,
        Contracts.NFT20Swapper
      );

      // console.log(state.CasContract);

      state.WrappedCats = new web3.eth.Contract(
        WrappedCatsABI,
        Contracts.WrappedCats
      );

      state.CatsCore = new web3.eth.Contract(CatsCoreAbi, Contracts.CatsCore);

      console.log("NEW ACCOUNT", state.account);
      if (state.isLoaded || state.isLoading) {
        return;
      }
      state.isLoading = true;

      const CoinGeckoClient = new CoinGecko();

      const coingeckoRes = await CoinGeckoClient.simple.price({
        ids: ["ethereum"],
        vs_currencies: ["usd"],
      });

      state.ethPrice = coingeckoRes.data.ethereum.usd;

      /*  Using API instead of web3 */
      let pools = await axios.get(
        "https://api.nft20.io/pools?perPage=200&network=" + state.network
      );
      let gh_assets = [];
      if (state.network == 0) {
        gh_assets = await axios.get(
          "https://raw.githubusercontent.com/verynifty/nft20-assets/master/assets.json"
        );
      } else {
        gh_assets = await axios.get(
          "https://raw.githubusercontent.com/verynifty/nft20-assets/master/assets_matic.json"
        );
      }
      let trendingPairs = [];
      pools = pools.data.data;
      for (const pool of pools) {
        const result = gh_assets.data.filter(
          (asset) => asset.symbol == pool.symbol
        );
        let logo = "https://placehold.it/300/300";
        let name = pool.name;
        let uniswap = `https://app.uniswap.org/#/add/ETH/${pool.address}`;
        if (state.network == 1) {
          (state.explorer = "https://polygonscan.com/address/"),
            (uniswap = `https://swap.cometh.io/#/add/ETH/${pool.address}`);
        }
        let factoryVersion = 2;
        let hide = false;
        let lpToken = false;
        let removedFees = false;
        let metadata = false;
        let metadataExtension = false;

        if (result.length > 0) logo = result[0].logo;
        if (result.length > 0) name = result[0].name;
        if (result.length > 0 && result[0].hide != null && result[0].hide)
          hide = true;
        if (result.length > 0 && result[0].uniswap) uniswap = result[0].uniswap;
        if (result.length > 0 && result[0].lpToken) lpToken = result[0].lpToken;
        if (result.length > 0 && result[0].factory_version)
          factoryVersion = result[0].factory_version;
        if (result.length > 0 && result[0].removedFees)
          removedFees = result[0].removedFees;

        if (result.length > 0 && result[0].metadata)
          metadata = result[0].metadata;
        if (result.length > 0 && result[0].metadata_extension)
          metadataExtension = result[0].metadata_extension;

        // console.log(pool)

        if (!hide) {
          let p = {
            name: pool.name,
            symbol: pool.symbol,
            type: parseInt(pool.nft_type),
            nftAddress: pool.nft,
            address: pool.address,
            supply: parseInt(pool.nft_value) * parseInt(pool.nft_locked),
            nftLocked: parseInt(pool.nft_locked),
            users_today: parseInt(pool.users_today),
            users_weekly: parseInt(pool.users_weekly),
            logo: pool.logo_url != null ? pool.logo_url : logo,
            uniswap,
            lpToken,
            nftValue: pool.nft_value,
            factoryVersion,
            totalLiquidity: parseFloat(pool.lp_usd_balance),
            removedFees,
            nftBasePrice: parseFloat(pool.nft_usd_price),
            nftBasePriceEth: parseFloat(pool.nft_usd_price) / state.ethPrice,
            metadata,
            metadataExtension,
          };
          trendingPairs.push(p);
          state.pairs.push(p);
        }
      }

      state.pairCount = parseInt(await state.Factory.methods.counter().call());
      console.log("set Web3");

      state.pairs = state.pairs.sort(function(a, b) {
        if (b.totalLiquidity - a.totalLiquidity != 0)
          return b.totalLiquidity - a.totalLiquidity;
        else return b.supply - a.supply;
      });

      trendingPairs = trendingPairs.sort(function(a, b) {
        return b.users_weekly - a.users_weekly;
      });
      state.trendingPairs = trendingPairs;
      state.isLoaded = true;
    },
    setCurrentProject(state, payload) {
      state.currentProject = payload;
    },
    setSelectedNfts(state, payload) {
      state.selectedNfts = payload;
    },
    setSelectedNftsIn(state, payload) {
      state.selectedNftsIn = payload;
    },

    setSelectedNftsOut(state, payload) {
      state.selectedNftsOut = payload;
    },
    setDidSelectNfts(state, payload) {
      state.didSelectNfts = payload;
    },
    setTokenSelected(state, payload) {
      state.tokenSelected = payload;
    },
    setCasWithdraw(state, payload) {
      state.casWithdraw = payload;
    },
    setCasDeposit(state, payload) {
      state.casDeposit = payload;
    },
    setCasPrice(state, payload) {
      state.casPrice = payload;
    },
  },
  actions: {
    connectWallet: async function(context, vue) {
      console.log("connecting");

      context.state.web3 = null;
      const provider = await vue.$web3Modal.connect();
      // provider.clearCachedProvider();
      provider.on("accountsChanged", (accounts) => {
        console.log("ACCOUNT CHANGED");
        context.dispatch("connectWallet", vue);
      });

      // Subscribe to chainId change
      provider.on("chainChanged", (chainId) => {
        context.dispatch("connectWallet", vue);
      });

      // Subscribe to provider disconnection
      provider.on("disconnect", (error) => {
        // context.dispatch("connectWallet", vue);
      });
      const web3 = new Web3(provider);
      context.commit("setWeb3", web3, vue);
    },
    disconnectWallet: async function(context, vue) {
      await vue.$web3Modal.clearCachedProvider();
      context.commit("disconnectWallet");
    },
    startWeb3: async function(context, vue) {
      let web3 = new Web3(
        new Web3.providers.WebsocketProvider(
          `wss://mainnet.infura.io/ws/v3/412acf21edf5444a8c9f6bd737cf8ca3`
        )
      );
      if (context.state.network == 1) {
        web3 = new Web3(
          new Web3.providers.HttpProvider(
            "https://rpc-mainnet.maticvigil.com/v1/a1ee017415be247f46ba9757b4ad2391d28df3da"
          )
        );
      }
      if (vue.$web3Modal.cachedProvider) {
        //This is case where someone already connected
        const provider = await vue.$web3Modal.connect();
        web3 = new Web3(provider);
        let chainId = await web3.eth.getChainId();
        console.log(chainId);
        if (context.state.network == 1 && chainId != 137) {
          context.state.correctNetwork = "Matic network";
        }
        if (context.state.network == 0 && chainId != 1) {
          context.state.correctNetwork = "Ethereum Mainnet";
        }
      }

      context.commit("setWeb3", web3, vue);
    },
  },
  modules: {},
});
